import { LinkLayerModel } from "@projectstorm/react-diagrams";
import { AdaptiveNodeProperty } from "../../Automation/NodeProperties/NodePropertyFactory";
import { AdaptiveNode } from "../../Automation/Nodes/NodeFactory";
import {
  automationSessionData,
  selectedAutomation,
  selectedAutomationNode,
  selectedAutomationNodeProperties,
  selectedAutomationTreeViewItem,
} from "../NewTemplateSignals";

export const AutomationPropertiesPane = () => {
  const handlePropertyChange = ({ e, propertyName }) => {
    // Get a reference to the model
    const model = selectedAutomation.value.model;
    const updatedProperties = {
      ...selectedAutomationNodeProperties.value,
      [propertyName]: e.target.value,
    };

    const oldNode = selectedAutomation.value.model.getNode(selectedAutomationNode.value.options.id);

    // Create new node
    const nodeConstructor = AdaptiveNode(oldNode.options.id.split("_")[0]);
    const newNode = new nodeConstructor({
      id: oldNode.id,
      color: oldNode.color,
      position: oldNode.position,
      nodeProperties: updatedProperties,
    });
    newNode.setSelected(true);

    // Remove the old node
    model.removeNode(oldNode);

    // Add the new node
    model.addNode(newNode);

    const linkLayer = model.layers.find((layer) => layer instanceof LinkLayerModel);

    if (linkLayer) {
      Object.values(linkLayer.models).forEach((link) => {
        if (link.sourcePort && link.sourcePort.parent.options.id === oldNode.options.id) {
          const sourcePort = newNode.getPorts()[link.sourcePort.options.name];
          const targetPort = link.getTargetPort();
          const newLink = sourcePort.link(targetPort);
          model.removeLink(link);
          model.addLink(newLink);
        }
        if (
          link.targetPort &&
          link.targetPort.parent.options.id === oldNode.options.id &&
          oldNode.options.extras.properties.Type !== "Function"
        ) {
          const sourcePort = link.getSourcePort();
          const targetPort = newNode.getPorts()[link.targetPort.options.name];
          const newLink = sourcePort.link(targetPort);
          model.removeLink(link);
          model.addLink(newLink);
        }
        if (
          oldNode.options.extras.properties.Type === "Function" &&
          link.targetPort.parent.options.id === oldNode.options.id &&
          oldNode.options.extras.properties.Function !== newNode.options.extras.properties.Function
        ) {
          model.removeLink(link);
        } else if (
          oldNode.options.extras.properties.Type === "Function" &&
          link.targetPort.parent.options.id === oldNode.options.id &&
          oldNode.options.extras.properties.Function === newNode.options.extras.properties.Function
        ) {
          const sourcePort = link.getSourcePort();
          const targetPort = newNode.getPorts()[link.targetPort.options.name];
          const newLink = sourcePort.link(targetPort);
          model.removeLink(link);
          model.addLink(newLink);
        }
      });
    }

    automationSessionData.value = automationSessionData.value.map((automation) => {
      if (automation.id === selectedAutomationTreeViewItem.value) {
        return {
          ...automation,
          model: model,
        };
      }
      return automation;
    });
  };

  if (!selectedAutomationNodeProperties.value) return null;

  return Object.entries(selectedAutomationNodeProperties.value).map(([key, value]) => {
    return (
      <AdaptiveNodeProperty
        key={`${selectedAutomationNode.value.options.id}-${key}`}
        value={value}
        propertyType={key}
        handlePropertyChange={handlePropertyChange}
      />
    );
  });
};
